import { css } from '@emotion/react';
import { useAppScopeStore } from '@frontend/scope';
import { Chip } from '@frontend/design-system';
import { useAppointmentsCalendarViewProps } from '../../../../context/AppointmentsCalendarViewContext';

type Props = {
  hide?: boolean;
};

export const LocationChip = ({ hide = false }: Props) => {
  const { selectedLocationIds } = useAppScopeStore();
  const { selectedLocationIds: calendarLocationIds } = useAppointmentsCalendarViewProps();

  const calendarLocationCount = calendarLocationIds?.length || selectedLocationIds?.length;

  if (hide || selectedLocationIds?.length <= 1) return null;

  const showSingleChip = calendarLocationIds?.length === 1 && selectedLocationIds.length > 1;

  if (showSingleChip) {
    return <Chip.SingleChip css={chipStyle}>{1}</Chip.SingleChip>;
  }

  return <Chip.MultiChip css={chipStyle}>{calendarLocationCount}</Chip.MultiChip>;
};

const chipStyle = css({
  width: 'fit-content',
  maxWidth: 'unset',
});
